import React from 'react'
import { Link } from 'react-router'
import store from './store'

export default [
  {
    title: '推荐号',
    dataIndex: 'account',
    key: 'account',
    render: (text, record) => (
      <div>
        <span>{record.order_no}</span>
        <p>{record.created_at}</p>
      </div>
    )
  },
  {
    title: '客户/电话',
    dataIndex: 'phone',
    key: 'phone',
    render: (text, record) => {
      let _html = ''
      if (record.lead) {
        _html = (
          <div>
            <p>{record.lead.name || ''}</p>
            <p>{record.lead.phone || ''}</p>
          </div>
        )
      }

      return _html
    }
  },
  {
    title: '婚宴需求',
    dataIndex: 'demand',
    key: 'demand',
    render: (text, record) => {
      let _html = (
        <div>
          {record.order.price_end == 0 ? (
            <p>
              <span>{record.order.price_begin}</span> 元
            </p>
          ) : (
            <p>
              <span>{record.order.price_begin}</span> -{' '}
              <span>{record.order.price_end}</span> 元
            </p>
          )}
          {record.order.tables_end == 0 ? (
            <p>
              <span>{record.order.tables_begin}</span> 桌
            </p>
          ) : (
            <p>
              <span>{record.order.tables_begin}</span> -{' '}
              <span>{record.order.tables_end}</span> 桌
            </p>
          )}
        </div>
      )

      return _html
    }
  },
  {
    title: '订单状态',
    dataIndex: 'orderStatus',
    key: 'orderStatus',
    render: (text, record) => {
      let msg = '无效'
      let str = ''
      let _id = ''
      let _status = record.status
      switch (String(_status)) {
        case '-1':
          msg = '未派单'
          break
        case '0':
          msg = '未查看'
          if (record.time_remain == 0) {
            msg = '已过期'
          } else {
            //str='(剩余：'+store.formatSeconds(record.time_remain)+')'
            store._ts = record.time_remain

            _id = 'time_' + record.id
            setTimeout(() => {
              store.formatSeconds(record.id, _id)
            }, 1000)
          }
          break
        case '1':
          msg = '已查看'
          break
        case '2':
          msg = '已过期'
          break
        case '3':
          msg = '已查看'
          break
        case '4':
          msg = '跟进失败'
          break
        case '5':
          msg = '定金已付'
          break
        case '6':
          msg = '已退单'
          break
      }

      if (record.feedback) {
        switch (String(record.feedback.status)) {
          case '0':
            str = '(成单提交)'
            break
          case '1':
            str = '(成单通过)'
            break
          case '2':
            str = '(成单不通过)'
            break
          case '3':
            str = '(退单提交)'
            break
          case '4':
            str = '(退单通过)'
            break
          case '5':
            str = '(退单不通过)'
            break
        }
      }

      return (
        <div id={`${_id}btn`}>
          <p>{msg}</p>
          <p id={_id}>{str}</p>
        </div>
      )
    }
  },
  {
    title: '婚期',
    dataIndex: 'weddingData',
    key: 'weddingData',
    render: (text, record) => (
      <div>
        <p>{record.order.wedding_begin} 至</p>
        <p>{record.order.wedding_end}</p>
      </div>
    )
  },
  {
    title: '操作',
    key: 'action',
    render: (text, record) => {
      let _id = ''
      if (record.status == 0) {
        if (record.time_remain == 0) {
          return <span>过期订单</span>
        } else {
          _id = 'time_' + record.id
          return (
            <span name={_id}>
              <Link to={`/localMerchant/myOrder/info/${record.id}`}>
                查看详情
              </Link>
            </span>
          )
        }
      } else if (record.status == 2) {
        return <span>过期订单</span>
      } else {
        _id = 'time_' + record.id
        return (
          <span name={_id}>
            <Link to={`/localMerchant/myOrder/info/${record.id}`}>
              查看详情
            </Link>
          </span>
        )
      }
    }
  }
]
